import React from "react";

const LoadingSpinner:React.FC = ()=> {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}

export default LoadingSpinner;